import { Controller } from "stimulus"

// #1263: tabbladen in het afspraakdetail en -venster. De server zet het
// gekozen tabblad al (params[:tab]); dit wisselt zonder te herladen, met de
// pijltjestoetsen tussen de tabs, en opent het tabblad met het anker uit de
// url (#wachtlijst, #deelnemer-12).
// #1969: de onderdelen van het trainingsdetail staan onder elkaar, dus ook
// pijltje omhoog en omlaag; een link buiten de tabs (Snelle acties) kan met
// data-kies-tab ook een tabblad kiezen, en springt dan naar zijn anker.
// Het gekozen tabblad staat ook op het element (data-actieve-tab): het
// rechterpaneel toont per onderdeel andere kaarten. Staat het anker in een
// dichtgeklapt blok, dan gaat dat open.
export default class extends Controller {
  static targets = ["tab", "paneel"]

  connect() {
    const anker = window.location.hash.slice(1)
    if (!anker) return

    const doel = document.getElementById(anker)
    const paneel = doel && this.paneelTargets.find((kandidaat) => kandidaat.contains(doel))
    if (paneel) this.toon(paneel.dataset.tabPaneel)
  }

  kies(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    event.preventDefault()
    this.toon(event.currentTarget.dataset.tab || event.currentTarget.dataset.kiesTab)
    const anker = event.currentTarget.hash?.slice(1)
    const doel = anker && document.getElementById(anker)
    if (doel) {
      const blok = doel.closest("details")
      if (blok) blok.open = true
      doel.scrollIntoView({ block: "start", behavior: "smooth" })
    }
  }

  toets(event) {
    const verticaal = event.currentTarget.closest("[aria-orientation='vertical']")
    const toetsen = verticaal ? { ArrowRight: 1, ArrowLeft: -1, ArrowDown: 1, ArrowUp: -1 } : { ArrowRight: 1, ArrowLeft: -1 }
    const stap = toetsen[event.key]
    if (!stap) return

    event.preventDefault()
    const huidig = this.tabTargets.indexOf(event.currentTarget)
    const volgende = this.tabTargets[(huidig + stap + this.tabTargets.length) % this.tabTargets.length]
    this.toon(volgende.dataset.tab)
    volgende.focus()
  }

  toon(naam) {
    this.element.dataset.actieveTab = naam
    this.tabTargets.forEach((tab) => {
      const actief = tab.dataset.tab === naam
      tab.classList.toggle("is-actief", actief)
      tab.setAttribute("aria-selected", actief ? "true" : "false")
      tab.tabIndex = actief ? 0 : -1
    })
    this.paneelTargets.forEach((paneel) => { paneel.hidden = paneel.dataset.tabPaneel !== naam })
  }
}
